import { render, staticRenderFns } from "./BrandAddItem.vue?vue&type=template&id=8d3df0a0"
import script from "./BrandAddItem.vue?vue&type=script&lang=js"
export * from "./BrandAddItem.vue?vue&type=script&lang=js"
import style0 from "./BrandAddItem.vue?vue&type=style&index=0&id=8d3df0a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports